import { Link } from "react-router-dom";
import Star from "../Helpers/icons/Star";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import ShopServices from "../../apis/shop/ShopServices";
import { useEffect, useState } from "react";
import { ErrorToaster } from "../Helpers/toaster/Toaster";
import { Rating } from "@mui/material";

export default function Sallers() {

  const [loader, setLoader] = useState(false);

  // *For Top Seller
  const [topSeller, setTopSeller] = useState([]);
  const [imageBaseUrl, setImageBaseUrl] = useState();

  // *For Get Top Seller
  const getTopSellers = async () => {
    setLoader(true)
    try {
      let params = {
        search: '',
        page: 1,
        limit: 20
      }
      const { data, userImageBaseUrl } = await ShopServices.getTopSellers(params)
      setTopSeller(data)
      setImageBaseUrl(userImageBaseUrl)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  useEffect(() => {
    getTopSellers()
  }, []);

  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="sallers-page-wrapper w-full mb-[60px]">
        <PageTitle
          title="All Seller "
          breadcrumb={[
            { name: "home", path: "/" },
            { name: "Sellers", path: "/sellers" },
          ]}
        />
      </div>

      <div className="content-wrapper w-full mb-[60px]">
        <div className="container-x mx-auto w-full">
          <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-[30px] gap-5">
            {topSeller.map((item, index) => {
              const bgImagePath = '/assets/images/sallers-cover-1.png'
              const logoImagePath = '/assets/images/saller-8.png'
              return (
                <div key={index} data-aos="fade-up" className="item w-full">
                  <div
                    className="w-full sm:h-[328px] sm:p-[30px] p-5"
                    style={{
                      background: `url(${process.env.PUBLIC_URL}${bgImagePath}) no-repeat`,
                      backgroundSize: "cover",
                    }}
                  >
                    <div className="flex sm:flex-row flex-col-reverse sm:items-center justify-between w-full h-full">
                      <div className="flex flex-col justify-between h-full">
                        <div className="">
                          <h1 className="text-[30px] font-semibold  text-qblack">
                            {item?.store_name}
                          </h1>
                          <div className="flex space-x-2 items-center mb-[30px]">
                            <div className="flex">
                              <Rating name="half-rating-read" defaultValue={item?.rating} precision={0.5} readOnly />
                            </div>
                            <span className="text-[15px] font-bold text-qblack ">
                              {`(${item?.rating})`}
                            </span>
                          </div>
                        </div>

                        <div>
                          <Link to={`/seller-page/${item?.seller_id}`}>
                            <div className="w-[116px] h-[40px]">
                              <div className="yellow-btn flex justify-center">
                                <div className="flex space-x-2 items-center">
                                  <span>Shop Now</span>
                                  <span>
                                    <svg
                                      width="7"
                                      height="11"
                                      viewBox="0 0 7 11"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="1.0918"
                                        y="0.636719"
                                        width="6.94219"
                                        height="1.54271"
                                        transform="rotate(45 1.0918 0.636719)"
                                        fill="#fff"
                                      />
                                      <rect
                                        x="6.00195"
                                        y="5.54492"
                                        width="6.94219"
                                        height="1.54271"
                                        transform="rotate(135 6.00195 5.54492)"
                                        fill="#fff"
                                      />
                                    </svg>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>

                      <div>
                        <div className="flex sm:justify-center justify-start">
                          {item?.image ? (
                            <div className="w-[170px] h-[170px] rounded-full bg-white mb-[20px] flex justify-center items-center">
                              <img
                                src={`${imageBaseUrl}${item?.seller_id}/${item?.image}`}
                                alt=""
                                // width={'100px'}
                                // height={'auto'}
                                style={{ borderRadius: '50%' }}
                              />
                            </div>
                          ) : (
                            <div className="w-[170px] h-[170px] rounded-full bg-white mb-[20px] flex justify-center items-center">
                              <img
                                src={`${process.env.PUBLIC_URL}${logoImagePath}`}
                                alt=""
                              />
                            </div>
                          )}
                        </div>

                        <h1 className="sm:block hidden text-[30px] font-semibold  text-qblack text-center leading-none">
                          {item?.store_name}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
}
